import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getAddressesSelector = createSelector(membersState, (members) => members.addresses?.data);
